import { render, staticRenderFns } from "./IxMapScope.vue?vue&type=template&id=0c0ca232&scoped=true&lang=html&"
import script from "./IxMapScope.vue?vue&type=script&lang=js&"
export * from "./IxMapScope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0ca232",
  null
  
)

export default component.exports